module.exports = __webpack_public_path__ + "img/android.f164d3fa.png";